module.exports = __webpack_public_path__ + "static/media/rymdskepp.769ad4b1.svg";